import React from 'react';

const EmptyStateText = ({children, additionalclasses}) => {
    return (
        <p className={`custom-text-grey-400 poppins-regular text-[14px] text-center ${additionalclasses}`}>
            {children}
        </p>
    );
};

export default EmptyStateText;